import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { locations } from "../../../../../../redux/locations/action";
import { selectLocationsListItems } from "../../../../../../redux/locations/selector";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";


const ManagementLocations = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
  const [pageData, setPageData] = useState(1)
    const LocationsListItems = useSelector(selectLocationsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'LocationName', headerName: 'Name',isEdit: true },
        //   { field: 'LocationTypeId', headerName: 'Location Type', cellRenderer: 'libraryRendererComponent', cellRendererParams: { library: libraries.LocationType } },
          { field: 'CreatedOnUtc', headerName: 'Created On' },
          { field: 'ModifiedOnUtc', headerName: 'Modified On' }
      
        ]);
      }
      const fetchLocations=()=>{

        dispatch(locations.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/locations/list`,entity:'locations',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
       
      }
	useEffect(() => {
        createColumnDefs()
        fetchLocations()
	}, [pageData])

  const additionButtons: any = [
    {
      name: 'Add Locations',
      callback: () => handleAdd(),
    }
  ];
  const handleAdd=()=>{
    navigate(`${0}`)
  }
  const handleEdit=(data: any)=>{
    navigate(`${data?.Id}`)
  }
  const handleDelete=(data: any)=>{
    dispatch(locations.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/locations/delete`,
      entity: 'locations',
      jsonData: {
          Records: [
              {
                  Id: data?.Id
              }
          ]
      }
  })).then(() => {
    dispatch(locations.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/locations/list`,entity:'locations',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
  });
  } 
	return (
    <>
    {LocationsListItems?.isLoading ? 
    <PageLoader />
:   
		<Table columnData={columnDefs} rowData={LocationsListItems?.result?.items} setPageData={setPageData}
    paginationData={LocationsListItems?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Locations"   />
  }
  </> 
     
	);
};

export default ManagementLocations;


